module.exports = __webpack_public_path__ + "img/resource_spices.3198653a.png";